module.exports = __webpack_public_path__ + "img/icon_store_b.fa5d45c2.svg";